import { List, ListSubheader } from '@mui/material'
import React from 'react'

export const NotificationsList: React.FC = React.memo(({ children }) => {
  return (
    <List
      data-test-notifications-list
      aria-labelledby="notifications-list-section-header"
      // MUI defaults to rendering this as a ul, but it then renders other ListItem/ListItemButton components as divs
      // which causes a11y issues, so we control the type of element rendered for these items to avoid that
      component="nav"
      // max height and overflow setting avoids problems with dynamic height
      // making some items in the list unreachable when all sections are expanded,
      // as well as resolving a weird issue where scrolling the menu down when fully
      // expanded would cause it to close
      css={{ maxHeight: '75vh', overflow: 'scroll', maxWidth: 500 }}
      subheader={
        <ListSubheader component="div" id="notifications-list-section-header">
          Team Notifications
        </ListSubheader>
      }
    >
      {children}
    </List>
  )
})

NotificationsList.displayName = 'NotificationsList'
